var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_docx",
    "data-name": "icona docx",
    transform: "translate(-109 -134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1451",
    "data-name": "Raggruppa 1451",
    transform: "translate(112 134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_263",
    "data-name": "Tracciato 263",
    d: "M98.062,0A2.32,2.32,0,0,0,96,2.5v35A2.32,2.32,0,0,0,98.062,40h20.625a2.32,2.32,0,0,0,2.063-2.5V10L112.5,0Z",
    transform: "translate(-96)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_264",
    "data-name": "Tracciato 264",
    d: "M354.063,10h6.188L352,0V7.5A2.32,2.32,0,0,0,354.063,10Z",
    transform: "translate(-335.5)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_265",
    "data-name": "Tracciato 265",
    d: "M390.188,135.5,384,128h6.188Z",
    transform: "translate(-365.438 -118)",
    fill: "#cad1d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1452",
    "data-name": "Raggruppa 1452",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_266",
    "data-name": "Tracciato 266",
    d: "M62,257.417A1.451,1.451,0,0,1,60.75,259H33.25A1.451,1.451,0,0,1,32,257.417V241.583A1.451,1.451,0,0,1,33.25,240h27.5A1.451,1.451,0,0,1,62,241.583Z",
    transform: "translate(76 -91)",
    fill: "#285f8f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DOCX",
    transform: "translate(113 161)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOCX"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.fe5ad23c597c3f66f33ab49a600c4f24.svg";
export { ForwardRef as ReactComponent };